(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/middlewares/storage-middleware.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/middlewares/storage-middleware.js');
"use strict";


const logger = svs.core.log.getLogger('racing.game-engine.storage-middleware');
const getStorageKey = svs.racing.common.strings.getStorageKey;
const systemTypes = svs.racing.common.constants.systemTypes;
const storage = (dispatch, engine) => next => (state, action) => {
  const newState = next(state, action);
  if (engine.systemType !== systemTypes.RESULT) {
    if (action.type === 'INITIALIZE') {
      const storageKey = getStorageKey(action.race.raceId, engine.gameType, engine.systemType);
      const serializedData = svs.components.Storage.browser.get(storageKey, 'Racing');
      if (serializedData) {
        const parsedData = JSON.parse(serializedData);
        if (parsedData) {
          dispatch(engine.actions.trySetData(parsedData));
        }
      }
    } else {
      const storageKey = getStorageKey(state.meta.raceId, engine.gameType, engine.systemType);
      const toSerialize = engine.selectors.getSerializableData(newState);
      if (storageKey && toSerialize) {
        logger.info("Saving data with key ".concat(storageKey));
        svs.components.Storage.browser.set(storageKey, 'Racing', JSON.stringify(toSerialize), svs.components.Storage.constants.EXPIRES_24H);
      }
    }
  }
  return newState;
};
svs.racing.gameEngine.middlewares.storage = storage;

 })(window);